import RegistrationForm from '../../components/RegistrationForm/RegistrationForm';

const RegistrationUser = () => {
  return (
    <>
      <RegistrationForm />
    </>
  );
};

export default RegistrationUser;
